
const vip=[
	{
		path:'/rights-interests',
		name:'rights-interests',
		component:_=>import('@/pages/vip/rights-interests.vue'),
		meta: {
			title: 'VIP会员'
		},
	},
	{
		path:'/vip-info',
		name:'vip-info',
		component:_=>import('@/pages/vip/vip-info.vue'),
		meta: {
			title: '会员权益'
		},
	},
]

export default vip;